import axios from 'axios'
import endpoints from '@/api/endpoints'
import _ from 'lodash'

export default {
  async getServicesForDivision (divID) {
    return axios.get(endpoints.services + '?division=' + divID).then((response) => {
      return _.orderBy(response.data, 'number')
    })
  },
  async getServices () {
    return axios.get(endpoints.services).then((response) => {
      return _.orderBy(response.data, 'number')
    })
  },
  async getServiceItem (itemID) {
    return axios.get(endpoints.services + itemID + '/').then((response) => {
      return response.data
    })
  },
  async updateServiceItem (item) {
    return axios.patch(endpoints.services + item.id + '/', item).then((response) => {
      return response.data
    })
  },
  async newServiceItem (item) {
    return axios.post(endpoints.services, item).then((response) => {
      return response.data
    })
  }
}
